document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector("#create_customer");
  const regionSelect = document.getElementById('regionSelect');
  const comunaSelect = document.getElementById('comunaSelect');

  const messageError = {
    firstNameEmpty: 'Ingresa tu nombre',
    lastNameEmpty: 'Ingresa tu apellido',
    telEmpty: 'Ingresa tu celular',
    telFormat: 'Ingresa un celular de 9 dígitos',
    rutEmpty: 'Ingresa tu rut',
    rutFormat: 'Ingresa un rut valido',
    emailEmpty: 'Ingresa tu correo',
    emailFormat: 'Ingresa un email válido',
    passwordEmpty: 'Ingresa una contraseña',
    passwordFormat: 'La contraseña debe contener un mínimo de 8 caracteres',
    confirmPassword: 'Ingresa una contraseña',
    confirmPasswordFormat: 'La contraseña debe contener un mínimo de 8 caracteres',
    passwordNotMatch: 'Las contraseñas no coinciden',
    address1Empty: 'Ingresa tu dirección',
    regionEmpty: 'Selecciona una región',
    comunaEmpty: 'Selecciona una comuna',
  };
  fetch('https://calendar-app.kitchencenter.cl/api/calendar/regions')
    .then(response => response.json())
    .then(data => {
      // Poblar el select de regiones
      for (const region in data) {
        if (data.hasOwnProperty(region)) {
          const option = document.createElement('option');
          option.value = data[region][0].short_code;
          option.textContent = region;
          regionSelect.appendChild(option);
        }
      }

      // Evento para actualizar el select de comunas
      regionSelect.addEventListener('change', function () {
        const selectedRegion = regionSelect.value;
        comunaSelect.innerHTML = '<option value=""></option>'; // Limpiar comunas

        if (selectedRegion) {
          const comunas = data[Object.keys(data).find(key => data[key][0].short_code === selectedRegion)];
          comunas.forEach(comuna => {
            const option = document.createElement('option');
            option.value = comuna.district;
            option.textContent = comuna.district;
            comunaSelect.appendChild(option);
          });
        }
      });
    })
    .catch(error => console.error('Error al obtener las regiones:', error));


  // form.addEventListener('submit', function (event) {
  //   event.preventDefault();

  // });

  sendCreateCustomer = function(element) {

    const firstNameField = document.querySelector("#RegisterForm-FirstName");
    const firstNameError = document.querySelector("#RegisterForm-first-name-error");

    const lastNameField = document.querySelector("#RegisterForm-LastName");
    const lastNameError = document.querySelector("#RegisterForm-last-name-error");

    const address1Field = document.querySelector("#address");
    const addressError = document.querySelector("#address-error");

    const regionFieldDiv = document.querySelector("#regionBorderDiv");
    const regionError = document.querySelector("#region-error");

    const comunaFieldDiv = document.querySelector("#comunaBorderDiv");
    const comunaError = document.querySelector("#comuna-error");

    const telField = document.querySelector("#RegisterForm-tel");
    const telError = document.querySelector("#RegisterForm-tel-error");
    const telRegex = /^\d{9}$/;

    const rutError = document.querySelector("#RegisterForm-rut-error");

    const emailField = document.querySelector('#RegisterForm-email');
    const emailError = document.querySelector("#RegisterForm-email-error");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const passwordField = document.querySelector('#RegisterForm-password');
    const passwordError = document.querySelector("#RegisterForm-password-error");

    const confirmPasswordField = document.querySelector("#RegisterForm-password2");
    const confirmPasswordError = document.querySelector("#RegisterForm-password2-error");

    let submitForm = {
      firstNameValidate: false,
      lastNameValidate: false,
      telValidate: false,
      rutValidate: false,
      emailValidate: false,
      passwordValidate: false,
      confirmPasswordValidate: false,
      address1Validate: false,
      regionValidate: false,
      comunaValidate: false,
    };

    // first name
    if (firstNameField.value === '') {
      showError(firstNameField, firstNameError, messageError.firstNameEmpty);
    } else {
      hideError(firstNameField, firstNameError);
      submitForm.firstNameValidate = true;
    }

    // last Name
    if (lastNameField.value === '') {
      showError(lastNameField, lastNameError, messageError.lastNameEmpty);
    } else {
      hideError(lastNameField, lastNameError);
      submitForm.lastNameValidate = true;
    }

    // Address
    if (address1Field.value === '') {
      showError(address1Field, addressError, messageError.address1Empty);
    } else {
      hideError(address1Field, addressError);
      submitForm.address1Validate = true;
    }

    // Region
    if (regionSelect.value === '') {
      showError(regionFieldDiv, regionError, messageError.regionEmpty);
    } else {
      hideError(regionFieldDiv, regionError);
      submitForm.regionValidate = true;
    }

    // Comuna
    if (comunaSelect.value === '') {
      showError(comunaFieldDiv, comunaError, messageError.comunaEmpty);
    } else {
      hideError(comunaFieldDiv, comunaError);
      submitForm.comunaValidate = true;
    }

    // tel
    if (telField.value === '') {
      showError(telField, telError, messageError.telEmpty);
    }
    else if (!telRegex.test(telField.value)) {
      showError(telField, telError, messageError.telFormat);
    }
    else {
      hideError(telField, telError);
      submitForm.telValidate = true;
    }

    // rut
    var rutValue = document.querySelector(".rutFormat").value;
    var rutField = document.getElementById("RegisterForm-rut");

    if (rutValue != '') {
      if (rutValue.length > 8) {
        var isValid = isValidRut(rutValue, { minimumLength: true });
        if (isValid) {
          hideError(rutField, rutError);
          submitForm.rutValidate = true;
        } else {
          showError(rutField, rutError, 'Ingresa un RUT válido');
        }
      } else {
        showError(rutField, rutError, 'Ingresa un RUT válido');
      }
    } else {
      showError(rutField, rutError, 'Ingresa tu RUT');
    }

    // email
    if (emailField.value === '') {
      showError(emailField, emailError, messageError.emailEmpty);
    } else if (!emailRegex.test(emailField.value)) {
      showError(emailField, emailError, messageError.emailFormat);
    }
    else {
      hideError(emailField, emailError);
      submitForm.emailValidate = true;
    }

    // password
    if (passwordField.value === '') {
      showError(passwordField, passwordError, messageError.passwordEmpty);
    } else if (passwordField.value.length < 8) {
      showError(passwordField, passwordError, messageError.passwordFormat);
    }
    else {
      hideError(passwordField, passwordError);
      submitForm.passwordValidate = true;
    }

    // confirm password
    if (confirmPasswordField.value === '') {
      showError(confirmPasswordField, confirmPasswordError, messageError.confirmPassword);
    } else if (passwordField.value !== confirmPasswordField.value) {
      showError(confirmPasswordField, confirmPasswordError, messageError.passwordNotMatch);
    } else {
      hideError(confirmPasswordField, confirmPasswordError);
      submitForm.confirmPasswordValidate = true;
    }

    // Check if all fields are validated
    const allFieldsValidated = Object.values(submitForm).every(value => value === true);

    // Submit the form only if all fields are validated
    if (allFieldsValidated) {
      element.disabled = true;
      form.submit();

      // Obtener los datos del formulario
      var formData = new FormData(form);
      // Crear el objeto de datos
      var data = {
        name: formData.get('customer[first_name]'),
        lastname: formData.get('customer[last_name]'),
        phone: formData.get('customer[note][phone_number]'),
        company: formData.get('customer[note][rut]'),
        email: formData.get('customer[email]'),
        address: formData.get('address'),
        address2: formData.get('address2'),
        region: formData.get('region'),
        comuna: formData.get('comuna')
      };

      // Enviar los datos al endpoint usando fetch
      fetch('https://calendar-app.kitchencenter.cl/api/customers/new-address', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
    }
  }

  const emailField = document.querySelector('#RegisterForm-email');
  const emailError = document.querySelector("#RegisterForm-email-error");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  emailField.addEventListener('input', function (event) {
    const inputValue = event.target.value.trim();
    if (inputValue !== '' && emailRegex.test(inputValue)) {
      hideError(emailField, emailError);
    }
  });

  emailField.addEventListener('blur', function (event) {
    const inputValue = event.target.value.trim();
    if (inputValue !== '' && emailRegex.test(inputValue)) {
      hideError(emailField, emailError);
    } else {
      showError(emailField, emailError, messageError.emailFormat);
    }
  });


  const telField = document.querySelector('#RegisterForm-tel');
  const telError = document.querySelector("#RegisterForm-tel-error");
  const telRegex = /^\d{0,9}$/;
  telField.addEventListener('input', function (event) {
    let inputValue = event.target.value.trim();
    inputValue = inputValue.replace(/[^\d]/g, '');
    inputValue = inputValue.slice(0, 9);
    event.target.value = inputValue;
    if (inputValue !== '' && telRegex.test(inputValue) && inputValue.length == 9) {
      hideError(telField, telError);
    }
  });


  telField.addEventListener('blur', function (event) {
    const inputValue = event.target.value.trim();
    if (inputValue !== '' && telRegex.test(inputValue)) {
      hideError(telField, telError);
    } else {
      showError(telField, telError, messageError.telFormat);
    }
  });





  const firstNameField = document.querySelector('#RegisterForm-FirstName');
  const firstNameError = document.querySelector("#RegisterForm-first-name-error");
  firstNameField.addEventListener('input', function (event) {
    const inputValue = event.target.value.trim();
    if (inputValue !== '') {
      hideError(firstNameField, firstNameError);
    }
  });

  firstNameField.addEventListener('blur', function (event) {
    const inputValue = event.target.value.trim();
    if (inputValue === '') {
      showError(firstNameField, firstNameError, messageError.firstNameEmpty);
    } else {
      hideError(firstNameField, firstNameError);
    }
  });

  const lastNameField = document.querySelector('#RegisterForm-LastName');
  const lastNameError = document.querySelector("#RegisterForm-last-name-error");
  lastNameField.addEventListener('input', function (event) {
    const inputValue = event.target.value.trim();

    if (inputValue !== '') {
      hideError(lastNameField, lastNameError);
    }
  });

  lastNameField.addEventListener('blur', function (event) {
    const inputValue = event.target.value.trim();
    if (inputValue === '') {
      showError(lastNameField, lastNameError, messageError.lastNameEmpty);
    } else {
      hideError(lastNameField, lastNameError);
    }
  });

  const passwordField = document.querySelector('#RegisterForm-password');
  const passwordError = document.querySelector("#RegisterForm-password-error");
  passwordField.addEventListener('input', function (event) {
    const inputValue = event.target.value;

    if (inputValue === '') {
      showError(passwordField, passwordError, messageError.passwordEmpty);
    } else if (inputValue.length < 8) {
      showError(passwordField, passwordError, messageError.passwordFormat);
    } else {
      hideError(passwordField, passwordError);
    }
  });

  const confirmPasswordField = document.querySelector("#RegisterForm-password2");
  const confirmPasswordError = document.querySelector("#RegisterForm-password2-error");
  confirmPasswordField.addEventListener('input', function (event) {
    const inputValue = event.target.value;
    const passwordValue = passwordField.value;

    if (inputValue === '') {
      showError(confirmPasswordField, confirmPasswordError, messageError.confirmPassword);
    } else if (passwordValue !== inputValue) {
      showError(confirmPasswordField, confirmPasswordError, messageError.passwordNotMatch);
    } else {
      hideError(confirmPasswordField, confirmPasswordError);
    }
  });


  const rutError = document.querySelector("#RegisterForm-rut-error");
  const rutField = document.querySelector(".rutFormat");

  rutField.addEventListener('blur', function () {
    const rutValue = this.value;
    if (rutValue == '') {
      showError(this, rutError, 'Ingresa tu RUT');
    } else {
      if (rutValue.length > 8) {
        const isValid = isValidRut(rutValue, { minimumLength: true });
        if (isValid) {
          hideError(this, rutError);
        } else {
          showError(this, rutError, 'Ingresa un RUT válido');
        }
      } else {
        showError(this, rutError, 'Ingresa un RUT válido');
      }
    }
  });

  rutField.addEventListener('input', function (event) {
    const rutValue = this.value;
    const lastChar = rutValue.charAt(rutValue.length - 1);
    const validCharsRegex = /^[0-9kK.-]$/;

    if (rutValue.length > 0 && !validCharsRegex.test(lastChar)) {
      this.value = rutValue.slice(0, -1);
      return;
    }

    formatInput(this, false);

    if (rutValue.length > 8) {
      const isValid = isValidRut(rutValue, { minimumLength: true });
      if (isValid) {
        hideError(this, rutError);
      } else {
        showError(this, rutError, 'Ingresa un RUT válido');
      }
    } else {
      showError(this, rutError, 'Ingresa un RUT válido');
    }
  });

  function showError(field, errorField, errorMessage) {
    errorField.textContent = errorMessage;
    errorField.style.display = 'flex';
    field.style.borderColor = "#CA1722";
  }

  function hideError(field, errorField) {
    errorField.textContent = '';
    errorField.style.display = 'none';
    field.style.borderColor = '#9C9C9C';
  }
});


